import { type Html, html, View } from 'rune-ts';
import klass from './StudioButton.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

export interface StudioButtonData {
  label: string | Html;
  is_submit?: boolean;
  is_disabled?: boolean;
  color?: 'line_gray' | 'line_sky' | 'white' | 'sky';
  /**
   * 버튼 크기 설정
   * - small: 96x40px
   * - medium: 132x48px (기본값)
   * - large: 100% width, 52px height
   * - free: 모든 사이즈 제약 해제, custom_klass로 자유롭게 스타일링 가능
   */
  size?: 'small' | 'medium' | 'large' | 'free';

  /**
   * CSS 클래스명
   * size="free" 사용 시 CSS 커스텀 속성을 통해 버튼 크기 조절 가능:
   * --button-min-width, --button-min-height, --button-padding
   */
  custom_klass?: string;
  form_id?: string;
  index?: number;
}

export class StudioButton extends View<StudioButtonData> {
  override template() {
    const { color, label, size, is_disabled, is_submit, custom_klass = '', form_id } = this.data;

    return html`<button
      ${size ? `data-size=${size}` : ''}
      ${form_id ? `form=${form_id}` : ''}
      data-color="${is_disabled ? 'disabled' : (color ?? 'sky')}"
      type="${is_submit ? 'submit' : 'button'}"
      class="${klass.button} ${font('14_medium')} ${custom_klass}"
      ${is_disabled ? 'disabled' : ''}
    >
      ${label}
    </button>`;
  }

  public getLabel() {
    return this.data.label;
  }

  public setDisable(is_disabled: boolean) {
    this.data.is_disabled = is_disabled;
    this.redraw();
    return this;
  }

  getIndex() {
    return this.data.index ?? 0;
  }

  getLabel() {
    return this.data.label ?? '';
  }

  override redraw() {
    (this.element() as HTMLButtonElement).disabled = !!this.data.is_disabled;
    return super.redraw();
  }
}
